import { createBrowserRouter } from "react-router-dom";
import Login from "./views/login/login";
import Landing from "./shared-views/landing-page/landing";
import ChooseProfilePage from "./views/onboarding/choose-profile/choose-profile";
import Form from "./views/onboarding/form/form";
import DefaultProfile from "./default-views/profile/profile";
import DefaultEditProfile from "./default-views/edit-profile/edit-profile-wrapper";
import DefaultTemplates from "./default-views/templates/templates-wrapper";
import DefaultDashboard from "./default-views/dashboard/dashboard-wrapper";
import DefaultProjects from "./default-views/projects/projects";
import DefaultMessages from "./default-views/messages/messages-wrapper";
import DefaultSettings from "./default-views/settings/settings-wrapper";
import ProjectDetail from "./default-views/projects/project-detail";
import Portfolio from "./default-views/portfolio";
import NotFound from "./components/not-found";
import PurchasePage from "./shared-views/purchase/purchase";
import PurchaseSuccessPage from "./shared-views/purchase/purchase-success";
import PurchaseCancelPage from "./shared-views/purchase/purchase-cancel";
import OnBoardingRecruiter from "./recruiter-views/on-boarding/on-boarding"
import RecruiterDashboard from "./recruiter-views/dashboard/dashboard";
import RecruiterLogin from "./recruiter-views/login/login";
import RecruiterProfileWrapper from "./recruiter-views/profile/recruiter-profile-wrapper";
import RecruiterSettings from "./recruiter-views/settings/settings-wrapper";
import RoleGuard from "./components/role-guard";

export const router = createBrowserRouter([
  // --------------shared-------------------
  { path: '/', element: <Landing /> },
  { path: '/purchase', element: <PurchasePage /> },
  { path: '/purchase-success', element: <PurchaseSuccessPage /> },
  { path: '/purchase-cancel', element: <PurchaseCancelPage /> },

  // --------------shared-------------------

  { path: 'login', element: <Login /> },
  { path: 'onboarding/choose-profile', element: <ChooseProfilePage /> },
  { path: 'onboarding/form-profile', element: <Form /> },
    // portfolio routes
  { path: '/profile', element: <Portfolio /> },                  // own profile
  { path: '/profile/:profile_name', element: <Portfolio /> },    // profile by name
  { path: '/projects/:id', element: <ProjectDetail /> },          // public project detail

  // --------------------- default user -----------------------------------
  { 
    path: '/default/dashboard', 
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultDashboard />
      </RoleGuard>
    )
  },
  { 
    path: '/default/profile', 
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultProfile />
      </RoleGuard>
    )
  },
  { 
    path: '/default/edit-profile', 
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultEditProfile />
      </RoleGuard>
    )
  },
  { 
    path: '/default/templates', 
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultTemplates />
      </RoleGuard>
    )
  },
  { 
    path: '/default/projects', 
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultProjects />
      </RoleGuard>
    )
  },
  { 
    path: '/default/messages', 
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultMessages />
      </RoleGuard>
    )
  },
  {
    path: '/default/settings',
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <DefaultSettings />
      </RoleGuard>
    )
  },
  {
    path: '/default/projects/:id',
    element: (
      <RoleGuard allowedRoles={['default']} fallbackPath="/recruiter/home">
        <ProjectDetail />
      </RoleGuard>
    )
  },
  // --------------------- recruiter -----------------------------------
  { 
    path: '/recruiter/home', 
    element: (
      <RoleGuard allowedRoles={['recruiter']} fallbackPath="/default/profile">
        <RecruiterDashboard />
      </RoleGuard>
    )
  },
  { 
    path: '/recruiter/profile', 
    element: (
      <RoleGuard allowedRoles={['recruiter']} fallbackPath="/default/profile">
        <RecruiterProfileWrapper />
      </RoleGuard>
    )
  },
  {
    path: '/recruiter/settings',
    element: (
      <RoleGuard allowedRoles={['recruiter']} fallbackPath="/default/profile">
        <RecruiterSettings />
      </RoleGuard>
    )
  },
  { 
    path: '/recruiter/on-boarding', 
    element: <OnBoardingRecruiter />
  },
  { path: '/recruiter/login', element: <RecruiterLogin /> },

  // 404 catch-all
  { path: '*', element: <NotFound /> },
]);
